import * as React from 'react';
import {Badge} from 'reactstrap';
import { SubfilterCountProps } from './SubfilterCountContainer';


const SubfilterCountView = (props: SubfilterCountProps) => (
    props.count > 0 ? <span> <Badge color="secondary">{props.count}</Badge></span> : null
);

export default SubfilterCountView;